//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'about',
  data () {
    return {
      contentThree: [
        {
          title: '新一代的社交通讯',
          name: 'Social Communication',
          contentList: [
            '通讯、聊天合二为一 —— DNAer讯息系统  ',
            '品质控的福音，诸多聊天系统细节革命性迭代',
            ' 更爽洁的沟通体验，爱不释手'
          ],
          bg: '../../static/img/about-content-1.png'
        },
        {
          title: '看我想看的“世界”',
          name: 'See the world',
          contentList: [
            '想看的，爱看的，才是我要的  ',
            '用户自由定义“朋友圈”',
            '是自闭者的私密空间，也是社交者的自由世界'
          ],
          bg: '../../static/img/about-content-2.png'
        },
        {
          title: '数据资产，连接你我',
          name: 'Data assets',
          contentList: [
            '你创造、你使用、你受益  ',
            '帮助用户创造属于自己价值连城的流量数据资产自平台',
            '让数据的创造者、使用者成为数据的受益者'
          ],
          bg: '../../static/img/about-content-3.png'
        }
      ],
      topImg: [
        '../../static/img/about-top-1.png',
        '../../static/img/about-top-2.png',
        '../../static/img/about-top-3.png',
        '../../static/img/about-top-4.png',
        '../../static/img/about-top-5.png'
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/about.vue